<template>
  <div>
    <div class="view-title clearfix">
      <span>{{$t('T_BRIGHTNESS_CONTRAST_GUIDE')}}</span>
    </div>
    <div class="card-info">
      <ul class="info-ul">
        <li></li>
        <li>{{$t('T_BRIGHTNESS_ON_SCREEN_NIT')}} {{brightnessData | filterToFix1}}</li>
        <li>{{$t('T_BRIGHTNESS_ON_SCREEN_LX')}} {{brightnessDataLx | filterToFix1}}</li>
        <li>{{$t('T_CONTRAST_ON_SCREEN')}} {{contrastData | filterToFix2}}</li>
      </ul>
      <div class="img clearfix"  ref="brightNess" :style="{backgroundImage:'url(' + srcImage + ')', backgroundRepeat:'no-repeat', backgroundSize: 'contain'}">
        <div class="img_brightness">
          <div class="brightness-box" ref="brightnessBox">
            <div class="brightness-item"
                :style="{'background': item.color}"
                v-for="(item, index) in brightnessOptions"
                :key="index"></div>
          </div>
          <div class="img_brightness_line" :style="{'top': brightNessHeight}">
            <div class="brightness-line"></div>
            <img src="../../assets/parts/result/brightness_line.png" alt="EPSON"/>
            <div class="img_brightness_line_text">{{ $t(shwoText) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import Brightness from '@/assets/data/brightness.json'

export default {
  name: 'resultBrightnessGuide',
  data () {
    return {
      brightNessHeight: '0%',
      positinIndex: 1,
      imgArray: {},
      srcImage: '',
      shwoTextArray: ['T_CRITERION_INDICATION_BEST', 'T_CRITERION_INDICATION_RECOMMEND', 'T_CRITERION_INDICATION_ENOUGH', 'T_CRITERION_INDICATION_LIMIT', 'T_CRITERION_INDICATION_TOO_LOW'],
      shwoText: ''
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.init()
    })
  },

  methods: {
    init () {
      this.getBrightNessHeight()
    },

    getBrightNessHeight (value) {
      value = value || this.contrastData
      let brightNessHeight = 0
      for (let i = 0; i < this.brightnessOptions.length; i++) {
        this.positinIndex = i + 1
        if (value >= this.brightnessOptions[0].max) {
          brightNessHeight = 0
          this.shwoText = ''
          break
        } else {
          if (value >= this.brightnessOptions[i].min && value < this.brightnessOptions[i].max) {
            brightNessHeight = (this.brightnessOptions[i].max - value) / (this.brightnessOptions[i].max - this.brightnessOptions[i].min) * 0.2 + i * 0.2
            this.shwoText = this.shwoTextArray[i]
            break
          }
        }
      }

      this.brightNessHeight = this.$refs.brightnessBox.offsetHeight * brightNessHeight + 10 + 'px'
      if (isNaN(value)) {
        this.positinIndex = 1
      }
    },

    getConstratData (whiteNormal, aspectRatio, screenSize, brightness) {
      let whiteNormalNum = whiteNormal.split('ml')[0]
      let [aspectRatioX, aspectRatioY] = aspectRatio.split(':')
      return whiteNormalNum *
        (Math.pow(aspectRatioX, 2) + Math.pow(aspectRatioY, 2)) /
        (Math.pow(screenSize, 2) * aspectRatioX * aspectRatioY * Math.pow(0.0254, 2) * brightness) +
        1
    },

    getImgSrc (srcName) {
      if (!this.imgArray[srcName]) {
        this.imgArray[srcName] = require('@/assets/parts/result/' + srcName + '.jpg')
      }
      this.imgArray[srcName] = this.imgArray[srcName] || require('@/assets/parts/result/' + srcName + '.jpg')
      this.srcImage = this.imgArray[srcName]
    },
    getBrightness () {
      let brightness = '-'
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightness = this.Brightness.optionLens[i].brightness
            return brightness
          }
        }
      } else if (this.aspectRatio === '16:6') { // ust 新规机能4
        return this.selectedModelData.color * 0.67 + ''
      } else if (this.aspectRatio === '21:9') {
        return this.selectedModelData.color * 0.76 + ''
      }
      return this.selectedModelData.color
    },
    brightnessCoefficient () {
      let b = this.getBrightness()
      if (this.selectedLensData.lcd.aspectRatio === '16:10') {
        switch (this.aspectRatio) {
          case '16:10' :
            return b.split('ml')[0] * 100 / 100
          case '16:9' :
            return b.split('ml')[0] * 90 / 100
          case '4:3' :
            return b.split('ml')[0] * 83.34 / 100
          case '21:9' :
            return b.split('ml')[0] * 68.6 / 100
          case '16:6':
            return b.split('ml')[0] * 60 / 100
          default :
            break
        }
      } else if (this.selectedLensData.lcd.aspectRatio === '16:9') {
        switch (this.aspectRatio) {
          case '16:10' :
            return b.split('ml')[0] * 83.34 / 100
          case '16:9' :
            return b.split('ml')[0] * 100 / 100
          case '4:3' :
            return b.split('ml')[0] * 75 / 100
          case '21:9' :
            return b.split('ml')[0]
          case '16:6' :
            return b.split('ml')[0]
          default :
            break
        }
      } else if (this.selectedLensData.lcd.aspectRatio === '4:3') {
        switch (this.aspectRatio) {
          case '16:10' :
            return b.split('ml')[0] * 83.34 / 100
          case '16:9' :
            return b.split('ml')[0] * 75 / 100
          case '4:3' :
            return b.split('ml')[0] * 100 / 100
          default :
            break
        }
      }
    }
  },

  filters: {
    filterToFix1 (value) {
      return (value * 1).toFixed(1)
    },

    filterToFix2 (value) {
      if (isNaN(value)) {
        return value
      }
      return (value * 1).toFixed(1) + ':1'
    }
  },

  computed: {
    ...mapState([
      'selectedModelData',
      'gain',
      'graph',
      'selectedLensData',
      'screenSize',
      'brightness',
      'application',
      'aspectRatio'
    ]),

    brightnessData () {
      let b = this.brightnessCoefficient()
      return b * this.gain / (this.graph.scrnW * this.graph.scrnH * Math.PI / 10000)
    },

    brightnessDataLx () {
      let b = this.brightnessCoefficient()
      return b / (this.graph.scrnW * this.graph.scrnH / 10000)
    },

    contrastData () {
      let b = this.brightnessCoefficient() + ''
      let result = this.getConstratData(b, this.selectedLensData.lcd.aspectRatio, this.screenSize, this.brightness)
      return result > 200 ? this.$t('T_MAX_CONSTRAST') : result
    },
    brightnessOptions () {
      const APPLICATIONOPTIONS = {
        '0': [{
          max: 200,
          min: 20
        }, {
          max: 20,
          min: 15
        }, {
          max: 15,
          min: 8
        }, {
          max: 8,
          min: 3
        }, {
          max: 3,
          min: 0
        }],
        '1': [{
          max: 200,
          min: 15
        }, {
          max: 15,
          min: 10
        }, {
          max: 10,
          min: 7
        }, {
          max: 7,
          min: 5
        }, {
          max: 5,
          min: 0
        }],
        '2': [{
          max: 200,
          min: 15
        }, {
          max: 15,
          min: 7
        }, {
          max: 7,
          min: 5
        }, {
          max: 5,
          min: 3
        }, {
          max: 3,
          min: 0
        }],
        '3': [{
          max: 200,
          min: 10
        }, {
          max: 10,
          min: 5
        }, {
          max: 5,
          min: 4
        }, {
          max: 4,
          min: 3
        }, {
          max: 3,
          min: 0
        }],
        '4': [{
          max: 200,
          min: 80
        }, {
          max: 80,
          min: 50
        }, {
          max: 50,
          min: 30
        }, {
          max: 30,
          min: 20
        }, {
          max: 20,
          min: 0
        }],
        '5': [{
          max: 200,
          min: 15
        }, {
          max: 15,
          min: 7
        }, {
          max: 7,
          min: 5
        }, {
          max: 5,
          min: 3
        }, {
          max: 3,
          min: 0
        }]
      }
      const COLOROPTIONS = ['#dae3f3', '#b4c7e7', '#8faadc', '#2f5597', '#203864', '#8faadc']
      let temp = APPLICATIONOPTIONS[this.application] || []
      temp.forEach((item, i) => {
        item.color = COLOROPTIONS[i]
      })
      return temp
    }
  },

  watch: {
    contrastData (newValue, oldValue) {
      this.getBrightNessHeight(newValue)
    },

    application (newValue, oldValue) {
      let imgNameArray = [
        'meeting',
        'classroom',
        'hall',
        'living',
        'theatre',
        'hall'
      ]
      let tempName = imgNameArray[newValue] + '_' + this.positinIndex
      this.getImgSrc(tempName)
    },

    positinIndex (newValue, oldValue) {
      let imgNameArray = [
        'meeting',
        'classroom',
        'hall',
        'living',
        'theatre',
        'hall'
      ]
      let tempName = imgNameArray[this.application] + '_' + newValue
      this.getImgSrc(tempName)
    }
  }
}
</script>

<style scoped>
.result-brightnessguide {
  width: 470px;
  height: 361px;
  margin-top: 10px;
  border: 2px solid #bdbdbd;
  background: #fff;
}

.img {
  position: relative;
  width:320px;
  height: 210px;
}

.img_brightness {
  float: left;
  position: relative;
  font-size: 0;
  top: 50%;
  transform: translateY(-50%);
  line-height: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.65);
}

.img_contrast {
  margin-left: 8px;
}

.img_brightness_line {
  position: absolute;
  top: 0;
  left: 5px;
  transform: translateY(-50%);
  z-index: 111;
  width: 200px;
}

.img_brightness_line img {
  vertical-align:middle;
}

.brightness-item {
  height: 20%;
  width: 100%;
}

.brightness-box {
  height: 90%;
  width: 22.5px;
  margin: 5px;
}
.img_brightness_line_text {
  color: #fff;
  background: #10218b;
  height: 14PX;/*no*/
  line-height: 14PX;/*no*/
  font-size: 10px;
  width: auto;
  display: inline-block;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  padding-right: 5px;
  vertical-align:middle;
}

.brightness-line {
    width: 22.5px;
    height: 1px;
    vertical-align: bottom;
    display: inline-block;
    background: #10218b;
}
</style>
